export const notableLines = [
  "Interview is not a process to impress. It is a process of engaging and presenting yourself with confidence.",
  "Start practicing with an AI interviewer.",
  "Clarity beats memorization when the pressure rises.",
  "Practice until confidence sounds natural.",
  "Every answer should reveal how you think, not only what you know.",
  "Real interviews reward presence, structure, and calm reasoning.",
  "Confidence grows when feedback is immediate and specific.",
  "Train your communication before the opportunity arrives.",
];

export const contactCards = [
  {
    name: "Srujan Reddy",
    role: "AI Architect, Tampere University",
    linkedin: "https://www.linkedin.com/in/harisrujan2605/",
    email: "srujan@ignitz.net",
  },
  {
    name: "Lokesh E",
    role: "Associate Director, IIM Calcutta Alumni",
    linkedin: "https://www.linkedin.com/in/lokesh-eeranala-001b3327/",
    email: "lokesh.e@ignitz.net",
  },
];

export const presentationSlides = [
  {
    id: "hero",
    eyebrow: "AI Interview Practice",
    titleSegments: [
      { text: "Practice the interview", tone: "plain" },
      { text: "before it matters.", tone: "accent" },
    ],
    body:
      "Evaluate Yourself gives candidates a realistic interview room, live AI follow-ups, and a clear report on what to fix before the real round.",
    quote: "Practice until confidence sounds natural.",
    bullets: ["Live interview room", "Adaptive follow-ups", "Clear improvement report"],
    screen: "hero",
    actions: [
      { label: "Start Practicing", to: "/register", variant: "primary" },
      { label: "View Pricing", to: "/pricing", variant: "secondary" },
    ],
  },
  {
    id: "philosophy",
    eyebrow: "Why It Matters",
    titleSegments: [
      { text: "Interview is not", tone: "plain" },
      { text: "a process to impress.", tone: "accent" },
    ],
    body:
      "Strong candidates are remembered for how they think, communicate, and respond in the moment. The product trains that behavior directly.",
    quote: "Every answer should reveal how you think, not only what you know.",
    bullets: ["Less memorizing", "More structured answers", "Practice that feels real"],
    screen: "quote",
  },
  {
    id: "reveal",
    eyebrow: "Product Reveal",
    titleSegments: [
      { text: "A focused room", tone: "plain" },
      { text: "for serious practice.", tone: "accent" },
    ],
    body:
      "Candidates choose a round, enter the room, answer one question at a time, and leave with practical next steps.",
    screen: "studio",
  },
  {
    id: "interviewer",
    eyebrow: "Interview Practice",
    titleSegments: [
      { text: "Start practicing with", tone: "plain" },
      { text: "an AI interviewer.", tone: "accent" },
    ],
    body:
      "Your interviewer listens, asks follow-ups, and keeps the session conversational without losing the pressure of a real interview.",
    quote: "Clarity beats memorization when the pressure rises.",
    screen: "interviewer",
    bullets: ["Natural follow-up questions", "Formal interview pacing", "Supportive guidance without losing rigor"],
  },
  {
    id: "live-flow",
    eyebrow: "Interview Flow",
    titleSegments: [
      { text: "Practice the rhythm", tone: "plain" },
      { text: "of a real interview.", tone: "accent" },
    ],
    body:
      "The session runs like an interview, not a quiz: one question, one answer, a follow-up when the answer needs depth.",
    bullets: ["Technical, behavioral, and 360 formats", "One question at a time", "Built for focused practice"],
    screen: "studio",
  },
  {
    id: "signals",
    eyebrow: "Performance Intelligence",
    titleSegments: [
      { text: "See how you perform,", tone: "plain" },
      { text: "not just what you answer.", tone: "accent" },
    ],
    body:
      "The platform looks at clarity, reasoning, pacing, and confidence so candidates can see exactly what to improve.",
    screen: "signals",
    bullets: ["Communication flow", "Technical depth and reasoning", "Confidence and attention cues"],
  },
  {
    id: "report",
    eyebrow: "Report Clarity",
    titleSegments: [
      { text: "Feedback that tells you", tone: "plain" },
      { text: "what to fix next.", tone: "accent" },
    ],
    body:
      "After every session, candidates get strengths, weak spots, and specific practice priorities instead of vague encouragement.",
    screen: "report",
    bullets: ["Breakdowns and patterns", "Improvement guidance", "Evidence-backed session recap"],
  },
  {
    id: "coverage",
    eyebrow: "Coverage",
    titleSegments: [
      { text: "One workspace", tone: "plain" },
      { text: "for every important interview mode.", tone: "accent" },
    ],
    body:
      "Candidates can practice technical interviews, behavioral rounds, and mixed 360 sessions without learning a new workflow each time.",
    bullets: ["Technical interview practice", "Behavioral communication rounds", "360 sessions for realistic mixed assessments"],
    screen: "coverage",
  },
  {
    id: "confidence-loop",
    eyebrow: "Progress Loop",
    titleSegments: [
      { text: "Confidence grows", tone: "plain" },
      { text: "with repeated, visible improvement.", tone: "accent" },
    ],
    body:
      "The goal is not one perfect answer. Each session should make the next one sharper, calmer, and easier to review.",
    quote: "Confidence grows when feedback is immediate and specific.",
    bullets: ["Practice", "Review", "Refine", "Repeat"],
    screen: "loop",
  },
  {
    id: "waitlist",
    eyebrow: "Free Trial Waitlist",
    titleSegments: [
      { text: "Join the waitlist", tone: "plain" },
      { text: "for free trials.", tone: "accent" },
    ],
    body:
      "Start with a short trial, collect feedback, and convert candidates who want deeper practice and reporting.",
    screen: "waitlist",
  },
  {
    id: "contact",
    eyebrow: "Connect With Us",
    titleSegments: [
      { text: "Thanks", tone: "accent" },
      { text: "for your time.", tone: "plain" },
    ],
    body:
      "Connect with us for demos, pilots, product feedback, or candidate preparation partnerships.",
    quote: "Train your communication before the opportunity arrives.",
  },
];
